import React from "react";

interface SectionHeaderProps {
  headerText: string;
  subHeaderText?: string;
  subheaderLink?: string;
  subheaderLinkText?: string;
}

function SectionHeader({ headerText, subHeaderText, subheaderLink, subheaderLinkText }: SectionHeaderProps) {
  return (
    <div className="section-header-container">
      <h2 className="text-lg header">{headerText}</h2>
      <h3 className="sub-header">
        {subHeaderText}

        {subheaderLink && subheaderLinkText && (
          <a href={subheaderLink} target="_blank" className="ml-1 font-semibold underline" rel="noreferrer">
            {subheaderLinkText}
          </a>
        )}
      </h3>
    </div>
  );
}

export default SectionHeader;
